import { Button, Col, DatePicker, Divider, Form, Input, Radio, Row, Select, TimePicker } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import dayjs from 'dayjs';
//import { TransectionApiServices } from 'features/transaction_list/api/transection-api.service';
//NotificationFilterFormField
import { NotificationFilterFormFieldList, NotificationFilterFormValueslist } from 'features/notification/components/type';
import { useCreateList } from 'features/notification/use-cases/create-list';
//import { useUserContext } from 'features/users';
import { useGetDropDownData } from 'features/notification/use-cases/get-common-api-data';
import { useGetType } from 'features/notification/use-cases/get-type';
import { FormSectionsSeparator } from 'features/users/components/modals/form-sections-separator';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// interface Ticket {
//     Text: string;
//     Id: any;
// }



// type props = {
//     closeModal: () => void;
//     isOpen: boolean;
//     modalType: string
// };

type Item = {
    Id: number;
};


export const AddNotiModalList = ({ onClose, showModal, refetch, EditData }: { onClose: () => void; showModal: boolean, refetch: () => void, EditData: any }) => {

    const formName = 'add-shop-coupon-form';
    const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
    const [form] = Form.useForm<NotificationFilterFormValueslist>();
    const { isLoading, mutate } = useCreateList();
    const { data } = useGetType('' as any, { retry: false });
    // const [displayCount, setDisplayCount] = useState(10);
    // const { user } = useUserContext();
    // const userHasAccessToEventList: any = user?.user_id != 107093;
    //const [selected, setSelected] = useState('All'); 

    const handleClose = () => {
        onClose();
        form.resetFields();
    }

    const [eventSearchKey, setEventSearchKey] = useState("");
    const [categorySearchKey, setCategorySearchKey] = useState("");


    const { data: sportsCategory } = useGetDropDownData({
        flag: "sportcategory",
        searchId: 0,
        SearchKey: ""
    });

    const { data: eventList, isLoading: eventLoading } = useGetDropDownData({
        flag: "events",
        searchId: 0,
        SearchKey: eventSearchKey
    },
        {
            enabled: !!eventSearchKey && eventSearchKey?.trim().length > 0  // API will run only when value exists
        });

    const { data: categoryList, isLoading: categoryLoading } = useGetDropDownData({
        flag: "eventcategory",
        searchId: 0,
        SearchKey: categorySearchKey
    }, {
        enabled: !!categorySearchKey && categorySearchKey?.trim().length > 0  // API will run only when value exists
    });

    const { data: gender, isLoading: genderLoading } = useGetDropDownData({
        flag: "gender",
        searchId: 0,
        SearchKey: ""
    }, {
        enabled: !!showModal  // API will run only when value exists
    });

    const { data: ageGroupCategory, isLoading: ageGroupLoading } = useGetDropDownData({
        flag: "age",
        searchId: 0,
        SearchKey: ""
    }, {
        enabled: !!showModal  // API will run only when value exists
    });

    const { data: language, isLoading: languageLoading } = useGetDropDownData({
        flag: "language",
        searchId: 0,
        SearchKey: ""
    }, {
        enabled: !!showModal  // API will run only when value exists
    });



    const { t } = useTranslation();
    // const getInitialValues = {
    //     [NotificationFilterFormFieldList.TITLE]: undefined,
    //     [NotificationFilterFormFieldList.ANNOUNCEMENTTYPEID]: undefined,
    //     [NotificationFilterFormFieldList.CONTENT]: undefined,
    //     [NotificationFilterFormField.is_active]: true,
    // };


    const hanldeSuccess = () => {
        handleClose();
        refetch();
    }
    useEffect(() => {
        if (EditData != undefined) {

            const eventIds: Item[] = EditData.sportsTypeIds;
            const EventSearchKey_: string = eventIds.map((x) => x.Id).join(",");

            const eventCategoryIds: Item[] = EditData.eventIds;
            const CategorySearchKey_: string = eventCategoryIds.map((x) => x.Id).join(",");
            setCategorySearchKey(CategorySearchKey_);
            setEventSearchKey(EventSearchKey_);
            form.setFieldsValue({
                ...EditData,

                title: EditData.Title,
                sportsTypeIds: EditData.sportsTypeIds?.map((u: any) => u.Id),
                eventIds: EditData.eventIds?.map((u: any) => u.Id),
                eventCategoryIds: EditData.eventCategoryIds?.map((u: any) => u.Id),
                ageGroupIds: EditData.ageGroupIds?.map((u: any) => u.Id),
                announcement_type_id: EditData.notificationTypeId,
                content: EditData.NotificationContent,
                schedule_date: EditData.schedule_date
                    ? dayjs(EditData.schedule_date, "YYYY-MM-DDTHH:mm:ss")
                    : null,
                schedule_time: EditData.schedule_time
                    ? dayjs(EditData.schedule_time, "HH:mm:ss")
                    : null
            });
        } else {
            form.resetFields()
        }
    }, [EditData])

    const deliverType = Form.useWatch("deliveryType", form);
    const handleUpdate = (formData: any) => {


        if (deliverType == 2) {
            formData[NotificationFilterFormFieldList.SCHEDULEDATE] = formData[NotificationFilterFormFieldList.SCHEDULEDATE]?.format("YYYY-MM-DD");
            formData[NotificationFilterFormFieldList.SCHEDULETIME] = formData[NotificationFilterFormFieldList.SCHEDULETIME]?.format("HH:mm:ss");
        }

        formData[NotificationFilterFormFieldList.ID] = EditData?.NotificationId;

        mutate(formData, { onSuccess: hanldeSuccess });
    };

    return (
        <>
            <div className='popup'>
                <div className='modal_head'>
                    <h4> {EditData ? 'Edit List' : 'Add List'}</h4>
                    <button onClick={handleClose} className='close-btn'>
                        &times;
                    </button>
                </div>
                <div className='modal_body' >
                    <Form<NotificationFilterFormValueslist>
                        id={formName}
                        name={formName}
                        form={form}
                        layout='vertical'
                        // initialValues={getInitialValues}

                        onFinish={handleUpdate}
                        // requiredMark={'optional'}
                        onFinishFailed={() => {
                            setValidateTrigger(['onChange']);
                        }}
                        validateTrigger={validateTrigger}
                        disabled={isLoading}
                    >
                        <FormSectionsSeparator title={"Audience Targeting"}>

                            <Form.Item<NotificationFilterFormFieldList>
                                label="Type" name={NotificationFilterFormFieldList.ANNOUNCEMENTTYPEID}>
                                <Select
                                    placeholder="Please select"
                                    style={{ width: "100%" }}
                                    options={data?.items?.map((res: any) => ({
                                        label: res.title,
                                        value: res.id
                                    }))}
                                />
                            </Form.Item>

                            <Form.Item<NotificationFilterFormFieldList>
                                label="Sports Type" name={NotificationFilterFormFieldList.SPORTTYPE}>
                                <Select
                                    mode="multiple"
                                    placeholder="Please select"
                                    style={{ width: "100%" }}
                                    options={sportsCategory?.notificationDropDownList?.map((res: any) => ({
                                        label: res.title,
                                        value: res.id
                                    }))}
                                    onChange={(values: number[]) => {

                                        const searchKey = values.join(",");
                                        setEventSearchKey(searchKey);

                                    }}
                                />
                            </Form.Item>

                            <Form.Item

                                label={'Event Name'}
                                name={NotificationFilterFormFieldList.EVENTNAME}
                                //   initialValue={'All'}

                                rules={[{ required: true, message: t('validateMessages.custom.nomsg') }]}
                            >
                                <Select
                                    mode="multiple"
                                    showSearch
                                    loading={eventLoading}
                                    // value={selected} // <-- bind state here
                                    options={eventList?.notificationDropDownList?.map((res: any) => ({
                                        label: res.title,
                                        value: res.id
                                    }))}
                                    placeholder={"Select Event Name"}
                                    onChange={(values: number[]) => {

                                        const searchKey = values.join(",");
                                        setCategorySearchKey(searchKey);
                                        //setSelected(value);
                                    }}
                                // <--- Update state here

                                />
                            </Form.Item>

                            <Form.Item
                                // label={t('shops.formfield.fieldName.label')}
                                label={'Event Category'}
                                name={NotificationFilterFormFieldList.CATEGORYNAME}
                            //initialValue={'All'}
                            // rules={[
                            //     {
                            //         required: true,
                            //         message: t('validateMessages.custom.nomsg'),
                            //     },
                            // ]}
                            >

                                <Select
                                    mode="multiple"
                                    showSearch
                                    loading={categoryLoading}
                                    options={categoryList?.notificationDropDownList?.map((res: any) => ({
                                        label: res.title,
                                        value: res.id
                                    }))}
                                    // disabled={selected== 'All' }
                                    placeholder={"Select Category"}
                                // filterOption={(input, option) =>
                                //     (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                // }

                                />
                            </Form.Item>


                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item<NotificationFilterFormFieldList>
                                        label="Gender" name={NotificationFilterFormFieldList.GENDER}>
                                        <Select
                                            placeholder="Please select"
                                            style={{ width: "100%" }}
                                            loading={genderLoading}
                                            options={gender?.notificationDropDownList?.map((res: any) => ({
                                                label: res.title,
                                                value: res.id
                                            }))}
                                        />
                                    </Form.Item>
                                </Col>

                                <Col span={12}>
                                    <Form.Item<NotificationFilterFormFieldList>
                                        label="Age Group" name={NotificationFilterFormFieldList.AGEGROUP}>
                                        <Select
                                            mode="multiple"
                                            loading={ageGroupLoading}
                                            placeholder="Please select"
                                            style={{ width: "100%" }}
                                            options={ageGroupCategory?.notificationDropDownList?.map((res: any) => ({
                                                label: res.title,
                                                value: res.id
                                            }))}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>



                            <Divider />



                        </FormSectionsSeparator>
                        <FormSectionsSeparator title={"Delivery Setting"}>

                            <Form.Item label="Delivery Type" initialValue={1} 
                            >
                                <Radio.Group>
                                    <Radio value={1} defaultChecked>Instant Notification</Radio>
                                    <Radio value={2}>Scheduled Notification</Radio>
                                </Radio.Group>
                            </Form.Item>
                            {deliverType == 2 && (

                                <Row gutter={16}>

                                    <Col span={12}>
                                        <Form.Item
                                            label="Schedule Date"
                                            name={NotificationFilterFormFieldList.SCHEDULEDATE}
                                            rules={[{ required: true, message: "Please select date" }]}
                                        >
                                            <DatePicker
                                                style={{ width: "100%" }}
                                                format="DD/MM/YYYY"
                                                placeholder="DD/MM/YYYY"
                                            />
                                        </Form.Item>
                                    </Col>

                                    <Col span={12}>
                                        <Form.Item
                                            label="Schedule Time"
                                            name={NotificationFilterFormFieldList.SCHEDULETIME}
                                            rules={[{ required: true, message: "Please select time" }]}
                                        >
                                            <TimePicker
                                                style={{ width: "100%" }}
                                                format="HH:mm:ss"
                                                placeholder="00:00:00"
                                            />
                                        </Form.Item>
                                    </Col>

                                </Row>

                            )}




                        </FormSectionsSeparator>
                        <Divider />
                        <FormSectionsSeparator title={"Notification Content"}>
                            <Form.Item<NotificationFilterFormFieldList>
                                label="Language" name={NotificationFilterFormFieldList.NOTIFICATIONLANGUAGE}>
                                <Select

                                    placeholder="Please select"
                                    style={{ width: "100%" }}
                                    loading={languageLoading}
                                    options={language?.notificationDropDownList?.map((res: any) => ({
                                        label: res.title,
                                        value: res.id
                                    }))}
                                />
                            </Form.Item>
                            <Form.Item<NotificationFilterFormFieldList>
                                label={"Notification Title"}
                                name={NotificationFilterFormFieldList.TITLE}

                                rules={[
                                    {
                                        required: true,
                                        whitespace: true,
                                        message: t('validateMessages.custom.nomsg'),
                                    },
                                ]}
                            >
                                <Input
                                    placeholder={"Enter Title"}
                                />
                            </Form.Item>
                            <Form.Item<NotificationFilterFormFieldList>
                                label={'Message'} name={NotificationFilterFormFieldList.CONTENT}>
                                <TextArea />
                            </Form.Item>
                        </FormSectionsSeparator>





                        <div className='form-button'>
                            <Button htmlType='submit' className='btn' type='primary'>Save</Button>
                        </div>
                    </Form>
                </div>
            </div >
        </>
    )
};

